const INTERVAL_MS = 8000;

export function initHeroRoulette() {
  const roulette = document.getElementById('hero-roulette');
  const dotsWrap = document.getElementById('hero-dots');
  if (!roulette || !dotsWrap) return;

  const slides = Array.from(roulette.querySelectorAll('.ph'));
  const dots = Array.from(dotsWrap.querySelectorAll('button'));
  const copySlides = Array.from(document.querySelectorAll('#hero-copy .hero-copy-slide'));
  const prevBtn = roulette.querySelector('.roulette-arrow.prev');
  const nextBtn = roulette.querySelector('.roulette-arrow.next');
  let index = slides.findIndex((s) => s.classList.contains('is-active'));
  if (index === -1) index = 0;
  let timer = null;

  function show(next) {
    slides[index].classList.remove('is-active');
    dots[index].classList.remove('is-active');
    copySlides[index]?.classList.remove('is-active');
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('is-active');
    dots[index].classList.add('is-active');
    copySlides[index]?.classList.add('is-active');
  }

  function start() {
    stop();
    timer = window.setInterval(() => show(index + 1), INTERVAL_MS);
  }

  function stop() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      show(i);
      start();
    });
  });

  prevBtn?.addEventListener('click', () => {
    show(index - 1);
    start();
  });

  nextBtn?.addEventListener('click', () => {
    show(index + 1);
    start();
  });

  roulette.addEventListener('mouseenter', stop);
  roulette.addEventListener('mouseleave', start);

  start();
}

document.addEventListener('DOMContentLoaded', initHeroRoulette);
